import { createApp } from 'vue'
import options from './CheckoutStepOne.options'

const el = '.kb-component--checkout-step-one'

export default function (Store) {
    const DOM = document.querySelectorAll(el)

    if (DOM.length) {
        DOM.forEach((DOM) => {
            const component = createApp(options).use(Store)
            component.mount(DOM)
        })
    }
}
